var _excluded = ["media"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import withMedia from 'react-media-query-hoc/dist/with-media';
import HorizontalSlide from '../../components/horizontal-slide';
import CarouselSlide from '../../components/carousel-slide';
import * as styles from './browse-page.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BrowsePage = _ref => {
  var media = _ref.media,
    props = _objectWithoutProperties(_ref, _excluded);
  var SlideComponent = media.desktop ? CarouselSlide : HorizontalSlide;
  return ___EmotionJSX("div", {
    css: styles.browsePage
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, props.title), ___EmotionJSX(SlideComponent, props));
};
BrowsePage.propTypes = {
  title: PropTypes.string,
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    desktop: PropTypes.bool
  })
};
BrowsePage.defaultProps = {
  title: 'Property of the Week',
  media: {
    mobile: true
  }
};
export default withMedia(BrowsePage);
export { BrowsePage as BaseBrowsePage };